import * as React from 'react';
import { Box, Card, CardContent, CardMedia, Typography } from '@mui/material';
/*
    <Typography
        variant="body2"
        color="textSecondary"
        component="p"
        sx={{
            paddingLeft: 2,
            paddingRight: 2,
            margin: 0,
            marginBottom: '0.75rem',
            fontSize:
            {
                xs: '5.0vw',
                sm: '2.8vw',
                md: "1.8vw",
                lg: "1.95vw"
            },

        }}
    >
        Mikäli haluatte jakaa juhlistamme otettuja kuvia sosiaalisessa mediassa, voitte käyttää 
        hashtagia <a href='https://mobile.twitter.com/search?q=%23valioliiga'
        target="_blank" rel="noopener noreferrer">#XXXXX</a>, 
        jotta muutkin vieraamme löytävät upeat kuvateoksenne! 
    </Typography>
*/
export default function ImageCardTiedoksi({ para }) {
    return (
        <Box
            
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    maxWidth: {
                        xs: '80vw',
                        sm: '80vw',
                        md: '90vw',
                        lg: '90vw',
                    },
                }}
            >


                <Card
                    sx={{
                        display: 'flex',
                        //minWidth: '75vw',
                        flexDirection:
                        {
                            xs: 'column',
                            sm: 'column',
                            md: 'row-reverse',
                            lg: 'row-reverse'
                        },
                        width: {
                            xs: '85%',
                            sm: '85%',
                            md: '75%',
                            lg: '75%',
                        },
                        height: '100%',
                        
                    }}
                >

                    <CardMedia
                        sx={{
                            display: 'flex',
                            
                            width: { xs: '99%', sm: '99%', md: '50%', lg: '50%' },
                            minHeight: '99%',
                            margin: '0.5%',
                            borderRadius: '3px',
                        }}
                        component="img"
                        image={para.pic}
                        //title={para.pde}
                    />
                    <CardContent
                        sx={{
                            
                            display: 'flex',
                            flexDirection: 'column',
                            width: { xs: '100%', sm: '100%', md: '50%', lg: '50%' },
                            height: { xs: '100%', sm: '100%', md: '100%', lg: '100%' },
                            
                            /*
                            old 
                            width: { xs: '100%', sm: '100%', md: '50%', lg: '50%' },
                            height: { xs: '50%', sm: '50%', md: '100%', lg: '100%' },
                            */
                            padding: 0,
                            margin: 0,
                            p: 0,
                            '&:last-child': { pb: 0 },
                        }}
                    >
                        <Typography
                            gutterBottom variant="h5"
                            component="h2"
                            sx={{
                                paddingLeft: 2,
                                paddingRight: 2,
                                paddingTop: 2,
                                fontSize:
                                {
                                    xs: '6.8vw',
                                    sm: '4.5vw',
                                    md: "2.8vw",
                                    lg: "2.95vw"
                                },
                            }}
                        >
                            {para.hea}
                        </Typography>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            component="p"
                            sx={{
                                paddingLeft: 2,
                                paddingRight: 2,
                                margin: 0,
                                marginBottom: '0.75rem',
                                fontSize:
                                {
                                    xs: '5.0vw',
                                    sm: '2.8vw',
                                    md: "1.8vw",
                                    lg: "1.95vw"
                                },

                            }}
                        >
                            <b>Kutsutut henkilöt on nimetty kutsun kuoreen. </b> 
                            Mikäli teillä on kutsuihin liittyen kysyttävää
                            olettehan matalalla kynnyksellä yhteydessä morsiuspariin. 
                            Yhteystietomme löydätte postitse saapuneesta
                            kutsusta sekä erillisen otsikon alta tämän sivuston lopusta.
                        </Typography>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            component="p"
                            sx={{
                                paddingLeft: 2,
                                paddingRight: 2,
                                margin: 0,
                                marginBottom: '0.75rem',
                                fontSize:
                                {
                                    xs: '5.0vw',
                                    sm: '2.8vw',
                                    md: "1.8vw",
                                    lg: "1.95vw"
                                },

                            }}
                        >
                            Toivomme juhlavaa pukeutumista. <a 
                            href="https://www.haat.fi/artikkeli/haavieras-muista-nama-saannot"
                            target="_blank" rel="noopener noreferrer">
                            Häävieras, muista nämä säännöt ja ota hääjuhlaetiketti haltuun</a>.
                        </Typography>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            component="p"
                            sx={{
                                paddingLeft: 2,
                                paddingRight: 2,
                                margin: 0,
                                marginBottom: '0.75rem',
                                fontSize:
                                {
                                    xs: '5.0vw',
                                    sm: '2.8vw',
                                    md: "1.8vw",
                                    lg: "1.95vw"
                                },

                            }}
                        >
                            {para.tex3}
                        </Typography>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            component="p"
                            sx={{
                                paddingLeft: 2,
                                paddingRight: 2,
                                margin: 0,
                                marginBottom: '0.75rem',
                                fontSize:
                                {
                                    xs: '5.0vw',
                                    sm: '2.8vw',
                                    md: "1.8vw",
                                    lg: "1.95vw"
                                },

                            }}
                        >
                            {para.tex4}
                        </Typography>
                        
                    </CardContent>
                </Card>
            </Box>

        </Box>





    );
}
